



















import Vue from 'vue';

export default Vue.extend({
  name: 'ModelModalBase',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
  },
});
